import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/utils/apiRequest";
import { GET_INTERFACE_LANGUAGE } from "@/constants/Query";

export const useGetInterfaceLanguageRequest = (enabled?: boolean) => {
  return useQuery({
    queryKey: [GET_INTERFACE_LANGUAGE],
    queryFn: () => apiRequest(GET_INTERFACE_LANGUAGE, "get"),
    enabled,
  });
};
